<template>
  <div class="aplication">
    <div class="wrapper">
      <Tarja></Tarja>
      <Banner></Banner>
      <template v-if="logado">
        <!-- Desktop: navegação horizontal -->
        <nav class="portal-nav portal-nav-desktop">
          <router-link v-for="it in menuItens" :key="it.to" :to="it.to" class="portal-nav-link" active-class="ativa">
            <i :class="it.icon"></i> {{ it.label }}
            <el-badge v-if="it.badge > 0" :value="it.badge" type="danger" />
          </router-link>
          <a href="javascript:void(0)" class="portal-nav-link" @click="sair"><i class="el-icon-switch-button"></i> Sair</a>
        </nav>

        <!-- Mobile: botão que abre a gaveta lateral -->
        <div class="portal-nav-mobile">
          <button class="portal-hamburguer" @click="drawer = true">
            <i class="el-icon-menu"></i>
            <span>Menu</span>
            <el-badge v-if="naoLidasMsg > 0" :value="naoLidasMsg" type="danger" />
          </button>
        </div>

        <el-drawer :visible.sync="drawer" direction="ltr" size="270px" custom-class="portal-drawer" :with-header="true" title="Menu">
          <div class="portal-drawer-links">
            <router-link v-for="it in menuItens" :key="it.to" :to="it.to" class="portal-drawer-link" active-class="ativa" @click.native="drawer = false">
              <i :class="it.icon"></i> <span>{{ it.label }}</span>
              <el-badge v-if="it.badge > 0" :value="it.badge" type="danger" />
            </router-link>
            <a href="javascript:void(0)" class="portal-drawer-link" @click="sairDrawer"><i class="el-icon-switch-button"></i> <span>Sair</span></a>
          </div>
        </el-drawer>
      </template>
      <div class="container conteudo">
        <template>
          <router-view />
        </template>
      </div>
      <Footer></Footer>     
    </div>

    <el-dialog
      class="ss-loading"
      top="0"
      width="200px"
      :visible.sync="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center
    >
      <div style="text-align: center">
        <img src="/public/img/loading.gif" />
      </div>
    </el-dialog>
    <div v-if="getAmbiente() == 'homologacao'" class="tarja-ambiente-beta">
      Atenção! Este é um ambiente de teste - as matrículas realizadas aqui não possuem validade.
    </div>
  </div>
</template>
<script>
import Banner from '../components/Banner.vue';
import Footer from '../components/Footer.vue';
import Tarja from '../components/Tarja.vue';

export default {  
  name: "index",  
  data: () => ({
    loading: null,
    naoLidasMsg: 0,
    drawer: false,
  }),
  computed: {
    logado () { return !!this.$store.state.user.token },
    permissoes () { return this.$store.getters.permissoes },
    menuItens () {
      const p = this.permissoes
      const itens = [{ to: '/inicio', icon: 'el-icon-house', label: 'Início' }]
      if (p.ver_notas || p.ver_parecer) itens.push({ to: '/diario', icon: 'el-icon-document', label: 'Diário' })
      itens.push({ to: '/ocorrencias', icon: 'el-icon-warning-outline', label: 'Ocorrências' })
      if (p.baixar_material) itens.push({ to: '/materiais', icon: 'el-icon-folder-opened', label: 'Materiais' })
      itens.push({ to: '/calendario', icon: 'el-icon-date', label: 'Calendário' })
      itens.push({ to: '/cardapio', icon: 'el-icon-food', label: 'Cardápio' })
      itens.push({ to: '/mensagens', icon: 'el-icon-chat-dot-round', label: 'Mensagens', badge: this.naoLidasMsg })
      return itens
    }
  },
  async mounted() {

    if(localStorage.getItem('pa85726549Token')){
      this.$store.commit('setToken', JSON.parse(localStorage.getItem("pa85726549Token")));
      this.carregarPermissoes();
      this.carregarNaoLidasMsg();
    } else {

      this.$store.commit('logout');
    }
  },
  methods: {
    carregarPermissoes() {
      // Busca as permissões atuais (parametros_sistema) para montar menu/telas —
      // reflete mudanças feitas na configuração sem depender do payload de login.
      if (!localStorage.getItem('pa85726549Token')) return;
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/permissoes-modulo`, {}, this.$store.getters.getHeaderAuth)
        .then(r => { if (r.data && !r.data.erro) this.$store.commit('setPermissoes', r.data); })
        .catch(() => {});
    },
    carregarNaoLidasMsg() {
      if (!localStorage.getItem('pa85726549Token')) return;
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/mensagem/nao-lidas`, {}, this.$store.getters.getHeaderAuth)
        .then(r => { if (r.data && !r.data.erro) this.naoLidasMsg = r.data.total || 0; })
        .catch(() => {});
    },
    getAmbiente() {

      return 'producao';

      if((window.location.href).includes("https://escolar.pmvc.ba.gov.br")) {
        return 'producao';
      }else if((window.location.href).includes("localhost")) {
        return 'local';
      }
      return 'homologacao';
    },
    sair() { this.$store.commit('logout'); },
    sairDrawer() { this.drawer = false; this.sair(); },
  },
  created: function () {
    window.eventBus.$on("alert", (data) => {
      let time = 3000;
      if (data.type == "error" || data.type == "warning") {
        time = 6000;
      }
      this.$message({
        message: data.msg,
        type: data.type,
        duration: time,
      });
    });

    window.eventBus.$on("loading", (data) => {
      this.loading = data;
    });
  },
  components: { Banner, Tarja, Footer },
};
</script>
<style>
  .portal-nav {
    background: #fff;
    border-bottom: 1px solid #e0e0e0;
    padding: 0 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
  }
  .portal-nav-link {
    color: #303133;
    text-decoration: none;
    padding: 10px 16px;
    font-size: 14px;
    white-space: nowrap;
    border-bottom: 2px solid transparent;
  }
  .portal-nav-link:hover { background: #f5f7fa; color: #409eff; }
  .portal-nav-link.ativa { color: #409eff; border-bottom-color: #409eff; }

  /* Barra mobile com botão de menu (gaveta) */
  .portal-nav-mobile { display: none; background: #fff; border-bottom: 1px solid #e0e0e0; }
  .portal-hamburguer {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    background: transparent;
    border: none;
    padding: 12px 16px;
    font-size: 15px;
    color: #303133;
    cursor: pointer;
  }
  .portal-hamburguer i { font-size: 20px; color: #409eff; }

  /* Links dentro da gaveta (drawer) */
  .portal-drawer-links { display: flex; flex-direction: column; }
  .portal-drawer-link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 20px;
    color: #303133;
    text-decoration: none;
    font-size: 15px;
    border-bottom: 1px solid #f2f2f5;
  }
  .portal-drawer-link i { font-size: 18px; width: 22px; text-align: center; color: #606266; }
  .portal-drawer-link:hover { background: #f5f7fa; }
  .portal-drawer-link.ativa { color: #409eff; background: #ecf5ff; font-weight: 600; }
  .portal-drawer-link.ativa i { color: #409eff; }
  .portal-drawer .el-drawer__header { margin-bottom: 0; padding: 16px 20px; color: #303133; font-weight: 600; border-bottom: 1px solid #e0e0e0; }
  .portal-drawer .el-drawer__body { padding: 0; }

  @media (max-width: 640px) {
    .portal-nav-desktop { display: none; }
    .portal-nav-mobile { display: block; }
  }
  .tarja-ambiente-beta {
    background-color: #ff0000;
    color: #fff;
    text-align: center;
    font-weight: bold;
    padding: 5px;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
</style>